module.exports = __webpack_public_path__ + "img/01@2x.9c150dae.png";